import styled from '@emotion/styled'

export const StyledLogicSetConditions = styled.div`
  width: 250px;
  z-index: 2; // over overlay
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
`
